import { SubmissionError } from 'redux-form';

function registrationSubmit(values) {
    return fetch(process.env.REACT_APP_API_ENTRYPOINT + '/users', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            'username': values.username,
            'first_name': values.firstName,
            'last_name': values.lastName,
            'email': values.email,
            'plain_password': values.password
        })
    })
    .then(res => res.json())
    .then(data => {
        if (data.violations) {
            data.violations.map(prop => {
                let propertyPath = prop.propertyPath;
                const err = { _error: 'Registration Failed!' };
                err[propertyPath] = prop.message;
                throw new SubmissionError(err);
            });
        } else {
            window.location.hash = '/login';
        }
    });
}

export default registrationSubmit;
